import config from '@/config'

export const getStatus = res =>
  !!res.status && res.data && Object.is(res.data.code, config.errno)

export const filterUrl = url =>
  !~url.indexOf('http') ? window.$globalconfig.URLS.API + url : url

export const sleep = time => new Promise(resolve => setTimeout(resolve, time))

export const curUrl = () => window.location.href

export const redirectUrl = url => window.open(url)

export const getURLParameters = url =>
  (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
    (a, v) => (
      // eslint-disable-next-line no-sequences
      (a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a
    ),
    {},
  )

export const handlePrevent = ev => ev.preventDefault()

// 获取字符长度
export const getTextLength = str => {
  // eslint-disable-next-line no-control-regex
  return String(str).replace(/[^\x00-\xff]/g, 'aa').length
  // return String(str).replace(/[^\x00-\xff]/g, 'aa').length
}

const _toString = Object.prototype.toString
export const copy = source => {
  let newObj = []
  const isArr = _toString.call(source) === '[object Array]'
  const isObj = _toString.call(source) === '[object Object]'
  if (isArr) {
    source.map((it, idx) => {
      newObj.push(it)
    })
  }
  if (isObj) {
    newObj = {}
    Object.keys(source).map(it => {
      newObj[it] = source[it]
    })
  }
  return newObj
}

export const getDomPos = obj => {
  let pos = {
    left: 0,
    top: 0,
  }
  while (obj) {
    pos.left += obj.offsetLeft || 0
    pos.top += obj.offsetTop || 0
    obj = obj.offsetParent
  }
  return pos
}

export const IEVersion = function() {
  var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  var isIE =
    userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
  var isEdge = userAgent.indexOf('Edge') > -1 && !isIE
  var isIE11 =
    userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
    var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    var fIEVersion = parseFloat(RegExp['$1'])
    if (fIEVersion === 7) {
      return 7
    } else if (fIEVersion === 8) {
      return 8
    } else if (fIEVersion === 9) {
      return 9
    } else if (fIEVersion === 10) {
      return 10
    } else {
      return 6 // IE版本<=7
    }
  } else if (isEdge) {
    return 'edge' // edge
  } else if (isIE11) {
    return 11 // IE11
  } else {
    return -1 // 不是ie浏览器
  }
}

export const getPhoneType = type => {
  switch (type) {
    case 'android':
      return navigator.userAgent.toLowerCase().indexOf('android') !== -1
    // break
    case 'iphone':
      return navigator.userAgent.toLowerCase().indexOf('iphone') !== -1
    // break
    case 'ipad':
      return navigator.userAgent.toLowerCase().indexOf('ipad') !== -1
    // break
    case 'weixin':
      return navigator.userAgent.toLowerCase().indexOf('weixin') !== -1
    // break
    default:
      return navigator.userAgent.toLowerCase()
  }
}

export const isPC = () => {
  return (
    !getPhoneType('android') &&
    !getPhoneType('iphone') &&
    !getPhoneType('ipad') &&
    !getPhoneType('weixin')
  )
}

export const transforUrlToBlob = async src => {
  const req = new XMLHttpRequest()
  req.open('GET', src, true)
  req.responseType = 'blob'
  req.onload = function() {
    if (this.status === 200) {
      const videoBlob = this.response
      return URL.createObjectURL(videoBlob) // IE10+
    }
  }
  req.onerror = function() {}
  req.send()
}
